document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-variants').forEach(function (productVariants) {
    var variantsJson = productVariants.querySelector('#product-variants-json');
    if (!variantsJson) return;

    var variantData;
    try {
      variantData = JSON.parse(variantsJson.textContent);
    } catch (error) {
      return;
    }

    function getSelectedOptions() {
      var selected = [];

      productVariants.querySelectorAll('[data-js-product-variant]').forEach(function (variantOption) {
        var container = variantOption.querySelector('[data-js-product-variant-container]');
        if (!container) return;

        if (container.getAttribute('data-js-product-variant-container') == 'radio') {
          var checked = container.querySelector('input[type="radio"]:checked');
          if (checked) selected.push(checked.value);
        } else {
          selected.push(container.value);
        }
      });

      return selected;
    }

    function findMatchingVariant() {
      var selectedOptions = getSelectedOptions();

      return variantData.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option == selectedOptions[index];
        });
      });
    }

    function getImageFileName(imageUrl) {
      if (!imageUrl) return '';
      return imageUrl.split('?')[0].split('/').pop();
    }

    function getMediaIndex(gallery, variant) {
      if (!gallery || !variant) return null;

      if (variant.featured_media && variant.featured_media.id) {
        var media = gallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
        if (media) return media.getAttribute('data-index');
      }

      if (variant.featured_image && variant.featured_image.src) {
        var imageFileName = getImageFileName(variant.featured_image.src);
        var matchedIndex = null;

        gallery.querySelectorAll('.product-gallery-item img').forEach(function (image) {
          if (matchedIndex !== null) return;
          if (getImageFileName(image.currentSrc || image.src) == imageFileName) {
            var item = image.closest('.product-gallery-item');
            matchedIndex = item ? item.getAttribute('data-index') : null;
          }
        });

        return matchedIndex;
      }

      return null;
    }

    function setActiveThumbnail(productPage, index) {
      if (!productPage || index === null) return;

      productPage.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach(function (thumbnail) {
        thumbnail.classList.toggle('active', thumbnail.getAttribute('data-index') == String(index));
      });
    }

    function goToMedia(variant, attempts) {
      var productPage = productVariants.closest('product-page');
      var gallery = productPage ? productPage.querySelector('[data-js-product-gallery]') : document.querySelector('[data-js-product-gallery]');
      var index = getMediaIndex(gallery, variant);

      if (index === null) return;

      var moved = false;
      var cssSlider = gallery ? gallery.querySelector('css-slider') : null;

      if (cssSlider && typeof cssSlider.changeSlide == 'function') {
        cssSlider.changeSlide(index);
        moved = true;
      }

      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        var slickGallery = window.jQuery(productPage || document).find('.product-gallery-item-slider.slick-initialized');
        if (slickGallery.length) {
          slickGallery.slick('slickGoTo', parseInt(index, 10));
          moved = true;
        }
      }

      if (!moved && attempts < 10) {
        window.setTimeout(function () {
          goToMedia(variant, attempts + 1);
        }, 150);
      }

      setActiveThumbnail(productPage, index);
    }

    function syncImagePickerVisuals(variantOption, select) {
      if (!variantOption || !select) return;

      var selectedOption = select.options[select.selectedIndex];
      var selectedValue = select.value;
      var selectedImageUrl = selectedOption ? selectedOption.getAttribute('data-image-url') : '';
      var selectedLabel = variantOption.querySelector('[data-ys-variant-selected-label]');
      var dropdown = variantOption.querySelector('[data-ys-variant-dropdown]');
      var selectedSummary = dropdown ? dropdown.querySelector('[data-ys-variant-selected-summary]') : null;
      var selectedImage = dropdown ? dropdown.querySelector('[data-ys-variant-selected-image]') : null;

      if (selectedLabel) selectedLabel.textContent = selectedValue;
      if (selectedSummary) selectedSummary.textContent = selectedValue;

      if (selectedImage) {
        selectedImage.innerHTML = '';
        if (selectedImageUrl) {
          var image = document.createElement('img');
          image.src = selectedImageUrl;
          image.alt = selectedValue;
          image.loading = 'lazy';
          selectedImage.appendChild(image);
        } else {
          var fallback = document.createElement('span');
          fallback.textContent = selectedValue ? selectedValue.charAt(0) : '';
          selectedImage.appendChild(fallback);
        }
      }

      variantOption.querySelectorAll('[data-ys-variant-dropdown-option]').forEach(function (option) {
        var optionSelected = option.getAttribute('data-value') == selectedValue;
        option.classList.toggle('is-selected', optionSelected);
        option.setAttribute('aria-selected', optionSelected ? 'true' : 'false');
        option.setAttribute('aria-checked', optionSelected ? 'true' : 'false');
      });
    }

    function onVariantChanged() {
      var variant = productVariants.currentVariant || findMatchingVariant();
      if (variant) goToMedia(variant, 0);
    }

    productVariants.addEventListener('VARIANT_CHANGE', onVariantChanged);
    productVariants.addEventListener('change', function () {
      window.setTimeout(onVariantChanged, 0);
    });

    productVariants.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ys-variant-dropdown-option]');
      if (!button || !productVariants.contains(button) || button.disabled) return;

      var variantOption = button.closest('[data-js-product-variant]');
      var select = variantOption ? variantOption.querySelector('select[data-js-product-variant-container="select"]') : null;
      var value = button.getAttribute('data-value');
      if (!select || !value) return;

      if (select.value == value && button.classList.contains('is-selected')) return;

      event.preventDefault();
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncImagePickerVisuals(variantOption, select);

      var dropdown = button.closest('details[data-ys-variant-dropdown]');
      if (dropdown) dropdown.removeAttribute('open');

      window.setTimeout(onVariantChanged, 0);
    });

    window.setTimeout(onVariantChanged, 500);
  });
});
